<div class="w-p-100 flex flex-col">
  <mat-checkbox style="flex: 0 0 30px" particleAnalytics analyticsCategory="share-items-user"
                [(ngModel)]="isGroupChat"
                [disabled]="data.input.selectedUsers && data.input.selectedUsers.length !== 2"
                (change)="onChatSettingsChanged(isGroupChat)"
                analyticsAction="checkbox">
    New group
  </mat-checkbox>
  <mat-form-field class="w-p-100" appearance="outline" *ngIf="isGroupChat">
    <mat-label>Title</mat-label>
    <input matInput placeholder="Title" [(ngModel)]="chatTitle">
  </mat-form-field>


</div>

